const getCentre = (state) => {
  return state.map.centre
}
const getZoom = (state)  => {
  return state.map.zoom
}

export const getters = {
  getCentre,
  getZoom,
}
